export default "__VITE_ASSET__BmsveDgt__"